import { render, staticRenderFns } from "./jiankang.vue?vue&type=template&id=a849c82a&scoped=true"
import script from "./jiankang.vue?vue&type=script&lang=js"
export * from "./jiankang.vue?vue&type=script&lang=js"
import style0 from "./jiankang.vue?vue&type=style&index=0&id=a849c82a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a849c82a",
  null
  
)

export default component.exports